import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Center } from '@mantine/core';
import Tilt from 'react-parallax-tilt';

import { Progress } from '@mantine/core';
import NetworkButton from '../../../components/global/networkButton';
import { unstake } from '../../../httpcalls/contractThunk';

const ManageButton = (props) => {
    const dispatch = useDispatch();

    const epoch = useSelector(state => state.mainapp.stakingSlice.epoch)
    const stakingEarnedAmount = useSelector((state) => state.mainapp.stakingSlice.earnings)
    const stakedAt = useSelector((state) => state.mainapp.stakingSlice.stakingTime)
    const userIndex = useSelector((state) => state.mainapp.stakingSlice.userIndex)
    const unstakeLimits = useSelector((state) => state.mainapp.stakingSlice.unstakeLimits)


    let progressMeter = useMemo(() => {
        if (unstakeLimits.limit == unstakeLimits.count) return 100
        const progressMeter = unstakeLimits.count / (unstakeLimits.limit * .8) * 100
        return Math.min(100, Math.max(0, progressMeter));
    }, [epoch])

    let unstakeDayDifference = useMemo(() => {
        return Math.max(0, Math.ceil((new Date(stakedAt) - Date.now()) / (1000 * 60 * 60 * 24)));
    }, [stakedAt])


    const unstakeStaker = () => {
        if(unstakeDayDifference < 1 && unstakeLimits.count < unstakeLimits.limit) {
            dispatch(unstake())
        }
    }


    return (
        <>
            <div className='manage-button'>
                <h2>Unstake & Withdraw</h2>


                <div className='time-chip'>
                    <i className='material-icons'>watch_later</i>
                    <h3><span>{unstakeDayDifference}</span> Day Lock</h3>
                </div>
                <NetworkButton classes={ unstakeDayDifference < 1 && unstakeLimits.count < unstakeLimits.limit ? 'unstake-btn' : 'unstake-btn disabled-btn'}>
                <button onClick={() => {unstakeStaker()}} className={
                    unstakeDayDifference < 1 && unstakeLimits.count < unstakeLimits.limit ? 'unstake-btn' : 'unstake-btn disabled-btn'
                }>Unstake & Withdraw</button>
                </NetworkButton>
               
                <p className='unstake-info'>Receive locked Pluri of 21,000. Will be removed from future Epochs, no longer earning passive tax and staker rewards.</p>
            </div>
        </>
    );
};

export default ManageButton